import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import NFTMarketplaceHero from "./NFTMarketplaceHero";
import NFTMarketDevSer from "./NFTMarketDevSer";
import GlimpseOFOurNFT from "./GlimpseOFOurNFT";
import NFTMinting from "./NFTMinting";
import ReadytoBuildNFT from "./ReadytoBuildNFT";
import WhyChoose from "../../Wallet/NFT Wallet/WhyChoose";

function NFTMarketplace() {
  return (
    <>
      <Header />
      <NFTMarketplaceHero />
      <NFTMarketDevSer />
      <GlimpseOFOurNFT />
      <NFTMinting />
      <ReadytoBuildNFT />
      <WhyChoose />
      <Footer />
    </>
  );
}

export default NFTMarketplace;
